import { Component, OnInit } from '@angular/core';
import { TriggeredRoutes } from '@triggered/core';

@Component({
  selector: 'triggered-legal',
  templateUrl: './legal.view.html',
  styleUrls: ['./legal.view.scss']
})
export class LegalView implements OnInit {

  readonly links = [
    { text: 'Privacy Policy', route: `/${TriggeredRoutes.legal.privacyPolicy.full}` },
    { text: 'Terms and Conditions', route: `/${TriggeredRoutes.legal.termsAndConditions.full}` },
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
